import { Alerta, Button, Casilla, Row, Stack, TextArea, TextField } from "@/components";
import { hoyISO } from "@/lib/format";
import { FotosNovedad } from "./FotosNovedad";
import { useFormularioCumplido } from "./useFormularioCumplido";

export interface FormularioCumplidoProps {
  fid: number;
  hitoId: number;
  /** Avisar de entrada: sí en los hitos; en trámites, pagos y obra se elige (Mati, 2026-11-03). */
  avisar?: boolean;
  nombre: string;
  onGuardado: () => void;
  onCancelar: () => void;
}

/** Marca un sub-hito como cumplido: publica la novedad "Hito cumplido: …" con la explicación y las fotos. */
export function FormularioCumplido({ fid, hitoId, nombre, avisar, onGuardado, onCancelar }: FormularioCumplidoProps) {
  const f = useFormularioCumplido(fid, hitoId, onGuardado, avisar);

  return (
    <form onSubmit={(e) => void f.guardar(e)} noValidate>
      <Stack espacio={4}>
        <p>
          <span className="text-texto-suave">Hito: </span>
          <span className="font-semibold">{nombre}</span>
        </p>
        <TextField etiqueta="Fecha" type="date" max={hoyISO()} value={f.form.fecha} onChange={(e) => f.cambiar("fecha", e.target.value)} error={f.errores.fecha} />
        <TextArea
          etiqueta="Explicación"
          value={f.form.texto}
          onChange={(e) => f.cambiar("texto", e.target.value)}
          error={f.errores.texto}
          ayuda="Opcional. La ven los fiduciantes en la novedad, junto con las fotos."
        />
        <FotosNovedad fid={fid} f={f} />
        <Casilla etiqueta="Avisar a los fiduciantes" ayuda="Les llega a fiduciantes, contador y escribano que tengan los avisos prendidos." marcado={f.form.avisar} onCambio={(v) => f.cambiar("avisar", v)} />
        <Alerta texto={f.errorFotos ?? f.errorGuardar} />
        <Row justificar="fin" espacio={2}>
          <Button type="button" variante="secundario" onClick={onCancelar}>
            Cancelar
          </Button>
          <Button type="submit" cargando={f.guardando}>
            Marcar como cumplido
          </Button>
        </Row>
      </Stack>
    </form>
  );
}
